import { type Component } from "vue";
import { type SwiperOptions } from "swiper/types";

export type IBackendOptions = ISwiperListOptions | IInfiniteLoadingOptions | IBootstrapTableOptions | IExpandableOptions;

export interface IVueListOptions<O extends IBackendOptions = IBackendOptions> {
	backendOptions: O
	component: Component
	pageSize: number
}

export function isSwiper(options: IBackendOptions):
	options is ISwiperListOptions {
	return (options as SwiperOptions).direction !== undefined;
}

export function isInfiniteLoading(options: IBackendOptions):
	options is IInfiniteLoadingOptions {
	return (options as IInfiniteLoadingOptions).distance !== undefined;
}

export function isBootstrapTable(options: IBackendOptions):
	options is IBootstrapTableOptions {
	return (options as IBootstrapTableOptions).columnKeys !== undefined;
}

export function isExpandable(options: IBackendOptions):
	options is IExpandableOptions {
	return !isSwiper(options) && !isInfiniteLoading(options) && !isBootstrapTable(options);
}

// Our SwiperList.vue accepts the options understood by the underlying swiper
// library and some additional options that are added here.
export interface ISwiperListOptions extends SwiperOptions {
	slidesPerColumn: number
	displayAdjacentItems?: boolean
	useTransitionOnEmptying?: boolean
	maxSlidesPerView?: number
}

export interface IInfiniteLoadingOptions {
	// The distance to the viewport edge that triggers a reload
	distance: number
}

export interface IBootstrapTableOptions {
	columnKeys: string[]
	hover?: boolean
	striped?: boolean
	condensed?: boolean
	responsive?: boolean
}

export interface IExpandableOptions {
	/**
	 * The name of the transition to use for the <TransitionGroup> component.
	 * @default "mia-ExpandableList-transition"
	 */
	transitionName?: string
}
